import type { IStockRepository } from '@/features/stock/domain/repositories/IStockRepository.js';

interface Deps { stockRepository: IStockRepository; }

export function createDeleteTransactionUseCase({ stockRepository }: Deps) {
  return async function deleteTransaction(id: string): Promise<void> {
    return stockRepository.deleteTransaction(id);
  };
}
